import { Component, ContentChild, Input, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { SubSink } from 'subsink';
import { map } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { NavigationModel } from '../../../../core/models/navigation/navigation.model';
import { selectNavigation } from '../../../../core/state/navigation/navigation.selectors';
import { faArrowLeftLong } from '@fortawesome/pro-light-svg-icons';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  standalone: false,
})
export class PageHeaderComponent implements OnInit, OnDestroy {
  @Input() public pageTitle = '';
  @ContentChild('headerBarControlsTemplate') public headerBarControlsTemplate: TemplateRef<unknown>;
  @ContentChild('headerBarArbitraryDataTemplate')
  public headerBarArbitraryDataTemplate: TemplateRef<unknown>;
  public prevRoute = '';
  public prevTitle = '';
  protected readonly faArrowLeftLong = faArrowLeftLong;
  private readonly subs = new SubSink();

  constructor(
    private readonly router: Router,
    private readonly store: Store<NavigationModel>,
  ) {}

  ngOnInit(): void {
    this.initRouteChanged();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  public navBack(): void {
    void this.router.navigateByUrl(this.prevRoute);
  }

  private initRouteChanged(): void {
    this.subs.sink = this.store
      .select(selectNavigation)
      .pipe(map((storeData) => storeData))
      .subscribe((navigationData) => {
        if (!navigationData) {
          return;
        }

        this.pageTitle = this.pageTitle || navigationData.pageTitle;
        this.prevTitle = navigationData.prevTitle;
        this.prevRoute = navigationData.prevRoute;
      });
  }
}
